import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../../state/userAtom';

const ROLE_HIERARCHY = {
  admin: 3,
  editor: 2,
  viewer: 1
};

export const ProtectedRoute = ({ children, requiredRole = 'viewer' }) => {
  const user = useRecoilValue(userAtom);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const userLevel = ROLE_HIERARCHY[user.role] || 0;
  const requiredLevel = ROLE_HIERARCHY[requiredRole] || 0;

  if (userLevel < requiredLevel) {
    return <Navigate to="/" replace />;
  }

  return children;
};
